var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0606 0.453828C11.3418 0.73512 11.4998 1.11658 11.4998 1.51433C11.4998 1.91207 11.3418 2.29354 11.0606 2.57483L3.63557 9.99983L11.0606 17.4248C11.3338 17.7077 11.485 18.0866 11.4816 18.4799C11.4782 18.8732 11.3204 19.2494 11.0423 19.5276C10.7642 19.8057 10.388 19.9634 9.99467 19.9668C9.60138 19.9703 9.22248 19.8191 8.93957 19.5458L0.454072 11.0603C0.172866 10.779 0.0148926 10.3976 0.0148926 9.99983C0.0148926 9.60208 0.172866 9.22062 0.454072 8.93933L8.93957 0.453828C9.22086 0.172622 9.60233 0.0146484 10.0001 0.0146484C10.3978 0.0146484 10.7793 0.172622 11.0606 0.453828Z",
    fill: "#151516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.b35ccee6b1a6dce95d2183e37eac2e9d.svg";
export { ForwardRef as ReactComponent };